import { Card, ChevronLeftIcon, Skeleton, Text } from '@mercai/clever'
import { Link } from 'react-router-dom'

import { HeaderProps } from './header.type'

import styles from './header.module.css'

const HeaderDefault = ({
  description,
  link,
  title,
  className,
  actions,
}: HeaderProps) => {
  return (
    <Card className={`${styles.core} ${className}`}>
      <div className={styles.header}>
        {link && (
          <Link to={link}>
            <ChevronLeftIcon />
          </Link>
        )}

        <div className={styles.content}>
          {typeof title === 'string' ? (
            <Text variant="title-large" className={styles.title}>
              {title}
            </Text>
          ) : (
            title
          )}

          {typeof description === 'string' ? (
            <Text className={styles.description}>{description}</Text>
          ) : (
            description
          )}
        </div>
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </Card>
  )
}

const HeaderLoading = () => {
  return (
    <Card className={styles.core}>
      <div className={styles.content}>
        <Skeleton width="6.25rem" height="1.8rem" />
        <Skeleton width="12.5rem" height="1rem" />
      </div>
    </Card>
  )
}

export const Header = (props: HeaderProps) => {
  if (props.isLoading) {
    return <HeaderLoading />
  }

  return <HeaderDefault {...props} />
}
